import React, { useEffect, useRef, useState } from 'react';
import style from "./style.module.css";
import Link from '../../Link';
import AsyncGet from '../../Materials/AsyncGet';
import Spinner from '../../Spinner';
import { get } from 'lodash';
import Button from '../Button';
import FormGroup from '../FormGroup';
const BusinessFinder = (props) => {
    const { placeholder = "Find business (enter name)", icon = "Search",
        meta,
        input: { onChange, name, value, onBlur },
        onSelect = () => { },
        label, required, disabled,

    } = props;
    const [load, setLoad] = useState(false);
    const [keyword, setKeyword] = useState(value);
    const [showSuggs, setShowSuggs] = useState(false);
    const divRef = useRef(null);

    const handleClickOutside = (event) => {
        if (divRef.current && !divRef.current.contains(event.target)) {
            closeSearch();
        }
    };

    const fetchBusiness = () => {
        if (keyword) {
            setLoad(Date.now());
            setShowSuggs(true);
        }
    }

    const closeSearch = () => {
        setShowSuggs(false);
    }

    useEffect(() => {
        if (value) {
            setKeyword(value);
        }
    }, [value]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={style.finder} ref={divRef}>
            <FormGroup
                meta={meta}
                label={label}
                value={value}
                required={required}
                disabled={disabled}
                fieldName={name}
                fieldValue={value}
            >
                <div className={style.wrap}>
                    <input
                        placeholder={placeholder}
                        onChange={(e) => {
                            setKeyword(e.target.value);
                            onChange(e.target.value);
                            closeSearch();
                        }}
                        name={name}
                        value={keyword}
                        onBlur={onBlur}
                    />
                    {icon && (
                        <Button label="Find" onClick={() => fetchBusiness()} color="orange" size="tiny" className={style.findIcon} />
                    )}
                    <AsyncGet
                        url="/list/business-finder"
                        loadOnMount={load}
                        paramsData={{ keyword }}
                        permissionText={false}
                        render={({ fetching, loaded, data }) => {
                            return (
                                <>
                                    {showSuggs && <div className={style.dropdownOptions}>
                                        {fetching === true && loaded === false && <div className={`${style.item} ${style.loading}`}><Spinner /></div>}
                                        {fetching === false && loaded === true && <>
                                            {get(data, 'list') && get(data, 'list', []).length > 0 && get(data, 'list', []).map((item) => {
                                                return (
                                                    <Link className={style.item} key={get(item, 'id')}
                                                        onClick={() => {
                                                            onChange(get(item, 'name'));
                                                            setKeyword(get(item, 'name'));
                                                            closeSearch();
                                                            onSelect(item);
                                                        }}
                                                    >
                                                        <span>{get(item, 'name')}</span>
                                                    </Link>
                                                )
                                            })}
                                            {(!get(data, 'list') || get(data, 'list', []).length <= 0) &&
                                                <div className={style.item}>No addresses were found</div>
                                            }
                                        </>}
                                    </div>
                                    }
                                </>
                            )
                        }}
                    />
                </div>
            </FormGroup>
        </div>
    )
}

export default BusinessFinder;